import { render, staticRenderFns } from "./VxCellPercentage.vue?vue&type=template&id=458f9120&"
import script from "./VxCellPercentage.vue?vue&type=script&lang=js&"
export * from "./VxCellPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports